module.exports = __webpack_public_path__ + "img/medium.7e333518.svg";